import { formatDistance } from "date-fns";
import React from "react";
import { Table, Label } from "semantic-ui-react";
import EmailTemplatesActionButtons from "../EmailTemplatesActionButtons";

function isDefaultForSharing(emailTemplate) {
  return emailTemplate.defaultEmailTemplateType
    ? emailTemplate.defaultEmailTemplateType === "sharing"
    : emailTemplate.defaultForSharing === true;
}

function isDefaultForSigning(emailTemplate) {
  return emailTemplate.defaultEmailTemplateType
    ? emailTemplate.defaultEmailTemplateType === "signing"
    : emailTemplate.defaultForSigning === true;
}

function getDefaultRecipientRolesDisplay(emailTemplate) {
  if (Array.isArray(emailTemplate.defaultRecipientRoles)) {
    return emailTemplate.defaultRecipientRoles.length > 0
      ? emailTemplate.defaultRecipientRoles
      : [];
  }
  if (isDefaultForSharing(emailTemplate) || isDefaultForSigning(emailTemplate)) {
    return ["All roles"];
  }
  return [];
}

export default function EmailTemplatesListItem({
  emailTemplate,
  actionButtonMode,
}) {
  const defaultRecipientRoles = getDefaultRecipientRolesDisplay(emailTemplate);

  return (
    <Table.Row key={emailTemplate.id}>
      {/* <Table.Cell>{emailTemplate.name}</Table.Cell> */}
      <Table.Cell>
        {emailTemplate.title}
        {emailTemplate.templateSource === "manager" && (
          <Label size="mini" color="blue" style={{ marginLeft: "8px" }}>
            Manager Template
          </Label>
        )}
      </Table.Cell>
      <Table.Cell collapsing>
        {isDefaultForSharing(emailTemplate) ? (
          <Label size="mini" color="green">Yes</Label>
        ) : (
          "—"
        )}
      </Table.Cell>
      <Table.Cell collapsing>
        {isDefaultForSigning(emailTemplate) ? (
          <Label size="mini" color="green">Yes</Label>
        ) : (
          "—"
        )}
      </Table.Cell>
      <Table.Cell>
        {defaultRecipientRoles.length > 0
          ? defaultRecipientRoles.map((role) => (
              <Label key={role} size="mini" className="mini bottom margin">
                {role}
              </Label>
            ))
          : "—"}
      </Table.Cell>
      <Table.Cell collapsing>
        <p>
          {emailTemplate.updatedAt && emailTemplate.updatedAt instanceof Date
            ? formatDistance(emailTemplate.updatedAt, new Date(), {
                addSuffix: true,
              })
            : ""}
        </p>
      </Table.Cell>
      <Table.Cell collapsing>
        <EmailTemplatesActionButtons
          emailTemplate={emailTemplate}
          actionButtonMode={actionButtonMode}
        />
      </Table.Cell>
    </Table.Row>
  );
}
